// extracted by mini-css-extract-plugin
module.exports = {"root":"Consent_root__1hevz","content":"Consent_content__2rZUm","footer":"Consent_footer__288R_"};